import { Component } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-politica-cookies-modal',
  templateUrl: './politica-cookies-modal.component.html',
  styleUrls: ['./politica-cookies-modal.component.scss']
})
export class PoliticaCookiesModalComponent {
  
  dataAtualizacao: string;

  constructor(public dialogRef: MatDialogRef<PoliticaCookiesModalComponent>) {
    console.log('Modal de política de cookies instanciado (Material)');
    this.dataAtualizacao = new Date().toLocaleDateString('pt-BR');
  }

  close(): void {
    this.dialogRef.close();
  }
} 